import React, { useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Avatar from "react-avatar";
import { userContext } from "../context/user";
// import { getRequest } from "../utils/axios";
// import { IoIosNotificationsOutline } from "react-icons/io";
import styles from "../views/Admin/styles/dashboard.module.scss";
// import { IoMdLogOut } from "react-icons/io";
import axios from "axios";
import config from "../config";

const Header = ({ title, subTitle }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { userDetails, setUserDetails } = useContext(userContext);

  const LogOut = async () => {
    const response = await axios.get(`${config.apiUrl}/da/logout`, {
      withCredentials: true,
    });

    console.log(response);
    setUserDetails(response.data);
    localStorage.removeItem("/dashboard");
    localStorage.removeItem("/dashboard/manage");
    localStorage.removeItem(location.pathname);
    // console.log(userDetails);
    navigate("/");
  };

  // console.log("Admin user", userDetails);
  return (
    <div>
      <div className={`d-flex`}>
        <div>
          <div className={styles.hello}>{title}</div>
          <div className={styles.welcome}>{subTitle}</div>
        </div>
        <div className={`d-flex flex-1 justify-content-end me-3`}>
          <div className="hideOnMobile">
            {/* <IoIosNotificationsOutline
              className="mr-4"
              size={23}
              color="#0D5459"
            /> */}

            <Link to={`/dashboard/profile/${userDetails._id}`}>
              <Avatar name={userDetails?.userName} round={true} size={"60px"} />
            </Link>
          </div>
        </div>
      </div>

      <div className="d-flex flex-1 justify-content-end hideOnMobile">
        <div className={`${styles.smallNavs} hideOnMobile`}>
          <div>
            <Link className={styles.links}> Contact Supervisor</Link>
          </div>
          {userDetails?.isMainAdmin ? (
            <div>
              <Link to="/dashboard/admins" className={styles.links}>
                Admin
              </Link>
            </div>
          ) : (
            ""
          )}
          <div onClick={LogOut}>
            <Link className={styles.links}>Logout</Link>
          </div>
          {/* <div onClick={LogOut}>
            <IoMdLogOut size={25} />
            <span
              style={{ fontWeight: "600", cursor: "pointer" }}
            >
              Logout
            </span>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Header;
